<div style="display: inline-flex">
    <mat-checkbox
            [ngClass]="wrapperClasses"
            [name]="input.property"
            [formControl]="input.control"
            (change)="onCheckBoxClick($event)"
    ><mat-label [ngClass]="{'required': input.required}"><app-render-html [html]="input.label"></app-render-html></mat-label>
    </mat-checkbox>
</div>
<app-text-icon *ngIf="input.info" (clickEvent)="onClick()" [tooltip]="input.info"></app-text-icon>
<mat-error class="text-error">{{errorMessage}}</mat-error>
